import { render, staticRenderFns } from "./DataScreen_old.vue?vue&type=template&id=3dd79b04&scoped=true"
import script from "./DataScreen_old.vue?vue&type=script&lang=js"
export * from "./DataScreen_old.vue?vue&type=script&lang=js"
import style0 from "./DataScreen_old.vue?vue&type=style&index=0&id=3dd79b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd79b04",
  null
  
)

export default component.exports